module.exports = __webpack_public_path__ + "img/silver1.9d5ed629.png";